var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityBidsIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5078 15.5078C15.1797 15.8359 14.7839 16 14.3203 16C13.8568 16 13.4635 15.8385 13.1406 15.5156L9.5 11.875C9.10417 11.4792 8.94792 11.0052 9.03125 10.4531L6.07812 7.5C5.28646 8.13542 4.42708 8.63542 3.5 9C1.96875 8.20833 0.802083 7.04167 0 5.5C0.5 4.25 1.23177 3.14583 2.19531 2.1875C3.15885 1.22917 4.26562 0.5 5.51562 0C7.04688 0.802083 8.21354 1.96875 9.01562 3.5C8.64062 4.4375 8.13542 5.29688 7.5 6.07812L10.4531 9.03125C11.0052 8.94792 11.4792 9.10417 11.875 9.5L15.5156 13.1406C15.8385 13.4635 16 13.8568 16 14.3203C16 14.7839 15.8359 15.1797 15.5078 15.5078Z",
    fill: "#3457D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityBidsIconColor);
export default __webpack_public_path__ + "static/media/activity-bids-icon-color.a7bb279ccbc97b4892927ed6aa76d1fb.svg";
export { ForwardRef as ReactComponent };